import { useContext } from 'react';
//mui imports====

import { Paper } from '@mui/material';
import ArrayInputConfig from '../../../../Components/ArrayInputConfig';
import { FvpConfigContext } from '../../../../Contexts/FvpConfigContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../../../core/constants';
import SwitchInput from '../../../../Components/SwitchInput';
import useCommonStyles from '../../../../commonStyles';
import { Box } from '@mui/system';
//===============

const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;

/**
 * @name FallBackXmlConfig
 * @description This component is an editor used to manage Fallback XML Configuration at the site level.
 *
 * "fallbackXmlConfig": {
 *   "enabled": false,
 *   "vastTagUrls": []
 * }
 *
 * @param {{keyData: 'fallbackXmlConfig'}} keyData - A key used to identify the configuration within the fvpConfig object.
 */

const FallBackXmlConfig = ({ keyData }) => {
	const { fvpConfig, updateFvpConfig } = useContext(FvpConfigContext);
	const commonStyleClasses = useCommonStyles();
	const updateFallBackXmlConfig = (property, value) => {
		const clonedFvpConfig = structuredClone(fvpConfig);
		clonedFvpConfig.fallbackXmlConfig = clonedFvpConfig.fallbackXmlConfig || {
			enabled: false,
			vastTagUrls: []
		};
		clonedFvpConfig.fallbackXmlConfig[property] = value;
		updateFvpConfig(clonedFvpConfig);
	};

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<Box
				style={{
					padding: '6rem 5rem 1.4rem 5rem'
				}}
			>
				<SwitchInput
					system={SYSTEMS.FVP_PLAYER}
					isObjectEditor={false}
					keyData={keyData + '.enabled'}
					label="Enabled"
					disabled={false}
					defaultChecked={false}
					directValue={fvpConfig?.fallbackXmlConfig?.enabled}
					updateDirectValue={(value) => updateFallBackXmlConfig('enabled', value)}
				/>
				<ArrayInputConfig
					system={SYSTEMS.FVP_PLAYER}
					isObjectEditor={false}
					label="VastTags"
					keyData={keyData + '.vastTagUrls'}
					inputGridStyle={{ display: 'flex' }}
					directValue={fvpConfig?.fallbackXmlConfig?.vastTagUrls}
					updateDirectValue={(value) => updateFallBackXmlConfig('vastTagUrls', value)}
				/>
			</Box>
		</Paper>
	);
};

export default FallBackXmlConfig;
